import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const SuccessLine16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 2.32075C6.49377 2.32075 5.04923 2.9191 3.98417 3.98417C2.9191 5.04923 2.32075 6.49377 2.32075 8C2.32075 8.74581 2.46765 9.48431 2.75306 10.1734C3.03847 10.8624 3.4568 11.4885 3.98417 12.0158C4.51153 12.5432 5.13761 12.9615 5.82665 13.2469C6.51569 13.5323 7.25419 13.6792 8 13.6792C8.74581 13.6792 9.48432 13.5323 10.1734 13.2469C10.8624 12.9615 11.4885 12.5432 12.0158 12.0158C12.5432 11.4885 12.9615 10.8624 13.2469 10.1734C13.5323 9.48432 13.6792 8.74581 13.6792 8C13.6792 6.49377 13.0809 5.04923 12.0158 3.98417C10.9508 2.9191 9.50623 2.32075 8 2.32075ZM3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 8.91925 14.8189 9.8295 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.8295 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.8295 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.9255 5.20411C11.2732 5.45247 11.3538 5.93568 11.1054 6.28339L8.01063 10.6161C7.87844 10.8011 7.67151 10.9187 7.44486 10.9374C7.21821 10.9562 6.99478 10.8743 6.83396 10.7135L4.9771 8.85659C4.67495 8.55445 4.67495 8.06457 4.9771 7.76242C5.27924 7.46028 5.76912 7.46028 6.07127 7.76242L7.28232 8.97348L9.84624 5.38399C10.0946 5.03628 10.5778 4.95575 10.9255 5.20411Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
